module.exports = __webpack_public_path__ + "img/127.0774828c.jpg";